'use client';

import {
  useGetPlatformConfig,
  useMarketConfig,
  useMarketConfigCatalog,
} from '@morfi/backend-sdk-v2/client';

export interface CreationFeeParams {
  feeBpsBacking: number | undefined;
  feeBpsBuy: number | undefined;
  feeBpsSellNormal: number | undefined;
  feeSplitBackersBps: number | undefined;
  creationThresholdD6: string | undefined;
  isLoading: boolean;
  isError: boolean;
  configStatus: 'loading' | 'ready' | 'unavailable';
}

/** Omit the address only for creation; null is an unavailable existing proposal. */
export function useCreationFeeParams(
  enabled: boolean = true,
  address?: string | null,
): CreationFeeParams {
  const current = useGetPlatformConfig(
    { kind: 'market', fields: ['marketConfig'] },
    { enabled: enabled && address === undefined },
  );
  const catalog = useMarketConfigCatalog();
  const data = useMarketConfig(address === undefined ? current.data?.marketConfig : address);
  const isLoading =
    enabled && (catalog.status === 'loading' || (address === undefined && current.isPending));
  const configStatus = data !== undefined ? 'ready' : isLoading ? 'loading' : 'unavailable';
  return {
    feeBpsBacking: data?.feeBpsBacking,
    feeBpsBuy: data?.feeBpsBuy,
    feeBpsSellNormal: data?.feeBpsSellNormal,
    feeSplitBackersBps: data?.feeSplitBackersBps,
    creationThresholdD6: data?.creationThresholdD6,
    isLoading,
    isError: configStatus === 'unavailable',
    configStatus,
  };
}
